//七牛上传配置——旧
export  function getQiniuOption(type,params) {
	let {btnId,preId,self,setKey,setIndex,uptoken}=params;
	// setIndex 存在，为数组，在数组setKey中的位置
	return {
		runtimes: 'html5,html4',
		browse_button: btnId,
		max_file_size: type=='audio'?'100mb':'10mb',
		dragdrop: true,
		chunk_size: '4mb',
		uptoken: uptoken,
		domain: 'https://tikuqiniu.knowbox.cn/',
		drop_element: preId,
		get_new_uptoken: false,
		save_key: false,
		unique_names: true,
		auto_start: true,
		disable_statistics_report: true,
		log_level: 0,
		filters: {
			max_file_size: type=='audio'?'100mb':'10mb',
			prevent_duplicates: true,
			//Specify what files to browse for
			mime_types: [{
				title: "files",
				extensions: type=='audio'?"mp3,ogg":"png,jpg"
			}, ]
		},
		init: {
			'FilesAdded': function(up, files) {},
			'BeforeUpload': function(up, file) {},
			'UploadProgress': function(up, file) {},
			'UploadComplete': function() {},
			'FileUploaded': function(up, file, info) {
				let res = JSON.parse(info);
				let domain = up.getOption('domain');
				if (setIndex || setIndex === 0) {
					let newState = [...self.props[setKey]];
					newState[setIndex] = `${domain}${res.key}`;
					self.editParam({[setKey]: newState});
					return;
				}
				self.setState({
					[setKey]: `${domain}${res.key}`
				})
			}
		},
		'Error': function(up, err, errTip) {
			console.log(err.message);
		},
		'Key': function(up, file) {
			var key = "";
			// do something with key
			return key
		}
	}

}
export const baseQiniuOption={
	runtimes: 'html5,html4',
    browse_button: ``,
    max_file_size: '100mb',
    dragdrop: true,
    chunk_size: '4mb',
    uptoken:'',
    domain: 'https://tikuqiniu.knowbox.cn/',
    drop_element: ``,
    get_new_uptoken: false,
    save_key: false,
    unique_names: true,
    auto_start: true,
    disable_statistics_report:true,
    log_level: 0,
    filters: {
        max_file_size: '100mb',
        prevent_duplicates: true,
        //Specify what files to browse for
        mime_types: [
            { title: "image files", extensions: "mp3,AAC,jpeg,png,jpg" },
        ]
    },
    init: {
        'FilesAdded': function(up, files) {},
        'BeforeUpload': function(up, file) {},
        'UploadProgress': function(up, file) {},
        'UploadComplete': function() {},
        'FileUploaded': function(up, file, info) {},
        'Error': function(up, err, errTip) {
            console.log(err.message);
        }
        ,
        'Key': function(up, file) {}
       
    }
}

//form布局
export const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 6 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 14 },
  },
};








// WEBPACK FOOTER //
// ./src/constData/index.js